<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form
        ref="searchForm"
        :model="searchForm"
        label-width="100px"
        inline
        label-position="top"
      > 
      <el-form-item label="部门名称" prop="deptName">
          <el-input
            v-model="searchForm.deptName"
            placeholder="请输入部门名称"
            @keypress.enter.native="search"
          ></el-input>
        </el-form-item>
      <el-form-item label="模版名称" prop="templateName">
          <el-input
            v-model="searchForm.templateName"
            placeholder="请输入模版名称"
            @keypress.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="模版类型" prop="templateType">
          <DictDataSelect
            code="template_type"
            v-model="searchForm.templateType"
            placeholder="请选择模版类型"
            clearable
          >
          </DictDataSelect>
        </el-form-item>
        <el-form-item label="批次" prop="matVo.pc">
          <el-input
            v-model="searchForm.matVo.pc"
            placeholder="请输入批次"
            @keypress.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="物料编码" prop="matVo.wlbm">
          <el-input
            v-model="searchForm.matVo.wlbm"
            placeholder="请输入物料编码"
            @keypress.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据主体" prop="dataType">
          <DictDataSelect
            code="data_type"
            v-model="searchForm.dataType"
            placeholder="请选择数据主体"
            clearable
          >
          </DictDataSelect>
        </el-form-item>
        <el-form-item label="打印人名称" prop="createUserName">
          <el-input
            v-model="searchForm.createUserName"
            placeholder="请输入打印人名称"
            @keypress.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="callTime" label-width="120px">
          <el-date-picker
            v-model="callTime"
            clearable
            @clear="
              () => {
                callTime = [];
                searchForm.createTimeStart = '';
                searchForm.createTimeEnd = '';
              }
            "
            @change="dateChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <section>
          <div class="btnBox">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </div>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <!-- <li>
          <el-button
            type="primary"
            @click="handleExportTem"
            icon="el-icon-download"
            >导出</el-button
          >
        </li> -->
        <li>
          <el-button
            type="primary"
            icon="el-icon-delete"
            @click="handleClickClear"
            >一键清空</el-button
          >
        </li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="deptName"
          label="部门名称"
          min-width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="templateName"
          label="模版名称"
          min-width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="templateType"
          label="模版类型"
          min-width="100px"
          show-overflow-tooltip
        >
        <template slot-scope="{row}">
          {{row.templateType|template_type}}
        </template>
        </el-table-column>
        <el-table-column
          prop="matVo.pc"
          label="批次"
          min-width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="matVo.wlbm"
          label="物料编码"
          min-width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="dataType"
          label="数据主体"
          min-width="100px"
          show-overflow-tooltip
        >
        <template slot-scope="{row}">
          {{row.dataType|data_type}}
        </template>
        </el-table-column>
        <el-table-column
          prop="copies"
          label="标签打印数量"
          min-width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createUserName"
          label="打印人名称"
          min-width="100px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="打印时间"
          min-width="150px"
          fixed="right"
          sortable="custom"
          sort-by="CREATE_TIME"
        ></el-table-column>
        <!-- <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="
                () => {
                  let dom = $refs.InventoryRecordOperaWindow;
                  dom.$refs.form && dom.$refs.form.resetFields();
                  dom.open('详情查看', row, false);
                }
              "
              icon="el-icon-view"
              >查看</el-button
            >
            <el-button
              type="text"
              @click="deleteById(row)"
              icon="el-icon-delete"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <InventoryRecordOperaWindow
      ref="InventoryRecordOperaWindow"
      @success="handlePageChange"
    />
  </TableLayout>
</template>

<script>
import BaseTable from "@/components/base/BaseTable";
import TableLayout from "@/layouts/TableLayout";
import SearchFormCollapse from "@/components/common/SearchFormCollapse";
import Pagination from "@/components/common/Pagination";
import InventoryRecordOperaWindow from "./InventoryRecordOperaWindow";
import { exportExcelTemApi ,clearAllApi} from "@/api/print_logging";
export default {
  name: "print_logging",
  extends: BaseTable,
  components: {
    SearchFormCollapse,
    TableLayout,
    Pagination,
    InventoryRecordOperaWindow,
  },
  data() {
    return {
      callTime: "",
      // 搜索
      searchForm: {
        matVo:{
          pc:"",
          wlbm:"",
        },
        deptName:"",
        templateName:"",
        templateType:"",
        createTimeEnd: "",
        createTimeStart: "",
        createTime: "",
        createUserName: null,
        data: "",
        dataId: null,
        dataType: "",
        id: null,
        copies: null,
      },
    };
  },
  methods: {
    handleClickClear(){
      this.$confirm('此操作将一键清空【打印日志记录】的所有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAllApi()
        .then(res=>{
          this.$message({
            type: 'success',
            message: res||'一键清空成功!'
          });
        })
        .catch(err=>{
          this.$message({type:'error',message:err.message})
        })
        .finally(()=>{
          this.search()
        })
      }).catch(() => {});
    },
    reset() {
      for (let key in this.searchForm) {
        this.searchForm[key] = "";
      }
      this.callTime = [];
      this.search();
    },
    dateChange(val) {
      if (val && val.length) {
        this.searchForm.createTimeStart = this.$dayjs(val[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.searchForm.createTimeEnd = this.$dayjs(val[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        this.searchForm.createTimeStart = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    handleExportTem() {
      this.$dialog
        .exportConfirm("确认导出数据吗？")
        .then(() => {
          this.isExportLoading = true;
          exportExcelTemApi(this.searchForm)
            .then((res) => {
              this.download(
                res,
                true,
                "application/octet-stream",
                false,
                "导出数据成功"
              );
            })
            .catch((err) => {
              this.$message({ type: "error", message: err.message });
            })
            .finally(() => {
              this.isExportLoading = false;
            });
        })
        .catch(() => {});
    },
  },
  created() {
    this.config({
      module: "打印日志记录",
      api: "/print_logging",
      "field.id": "id",
      "field.main": "id",
      sorts: [
        {
          property: "CREATE_TIME",
          direction: "DESC",
        },
      ],
    });
    this.search();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .highlightRow {
  background: #bdd3e0;
}

.btnBox {
  line-height: 114px;
}
</style>